import styled from 'styled-components';
import { Link } from 'src/components/atoms';

export const PrivacyStatementLink = styled.div`
  display: flex;
  align-items: center;
  text-decoration: none;
  margin-bottom: 20px;
  flex-direction: column;
`;

export const StyledLink = styled(Link)`
  padding-top: 10px;
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
`;
